import React from "react";
import { Flex, Spin } from "antd";

/**
 * What the app shows while it cannot show anything else yet: Auth0 starting up,
 * a sign-in redirect leaving the page, a token being re-minted.
 *
 * Those states used to render nothing, which is indistinguishable from the app
 * having broken - and a redirect loop behind a blank page looks exactly like a
 * blank page.
 */
const FullPageSpin: React.FC = () => (
  <Flex align="center" justify="center" className="min-h-screen bg-white">
    <Spin size="large" />
  </Flex>
);

export default FullPageSpin;
